import { Table } from "@chakra-ui/react";
import { Cell, Row, flexRender } from "@tanstack/react-table";
import { Fragment, useCallback } from "react";
import { useNavigate } from "react-router-dom";

type InvoicesTableRowProps<T> = {
    row: Row<T>;
    submittedInvoiceId?: string;
};

type RowWithId = { id: string };

const InvoicesTableRow = <T extends RowWithId>({ row, submittedInvoiceId }: InvoicesTableRowProps<T>) => {
    const navigate = useNavigate();

    const handleKeyUp = useCallback(
        (e: React.KeyboardEvent<HTMLTableRowElement>) => {
            if (e.key === "Enter") {
                navigate("/invoice/" + row.original.id);
            }
        },
        [navigate, row.original.id]
    );

    const handleRowClick = useCallback(() => {
        navigate("/invoice/" + row.original.id);
    }, [navigate, row.original.id]);

    const handleBackgroundColor = (cell: Cell<T, unknown>) =>
        cell.getContext().column.getIsSorted() || row.getIsExpanded() ? "anchor.brown.100" : undefined;

    return (
        <Fragment key={row.id}>
            <Table.Row
                onClick={handleRowClick}
                backgroundColor={submittedInvoiceId === row.original.id ? "#F5F7F8" : "#FFFFFF"}
                _hover={{
                    cursor: "pointer",
                    backgroundColor: "#FAFBFB"
                }}
                tabIndex={0}
                onKeyUp={handleKeyUp}
            >
                {row.getVisibleCells().map(cell => {
                    return (
                        <Table.Cell
                            key={cell.id}
                            whiteSpace="nowrap"
                            textOverflow="ellipsis"
                            backgroundColor={handleBackgroundColor(cell)}
                            fontSize={"16px"}
                            wordBreak="break-word"
                            py="1rem"
                        >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </Table.Cell>
                    );
                })}
            </Table.Row>
        </Fragment>
    );
};

export default InvoicesTableRow;
